export default __webpack_public_path__ + "static/media/BootsSharp-Regular.2f729785.woff";